// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 76 ? "common" : chunkId) + "." + {"36":"b9c265c8704c8185","76":"5ed9b9e4e57e3b82","331":"9d22d1a42a85e80b","489":"767238b34fe458de","995":"efd3fa70ff5bccbc"}[chunkId] + ".js";
};